module.exports = __webpack_public_path__ + "img/chat_gpt_icon.18d7d841.svg";